import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Menu, Search} from 'lucide-react';
import SearchBar from './SearchBar';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  const goSearch = () => {
    navigate(`/search`);
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="p-2 rounded-md hover:bg-gray-100 transition-colors duration-200 lg:hidden"
          >
            <Menu className="h-5 w-5 text-gray-600" />
          </button>

          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <img
                src="/images/das-logo.svg"
                alt="DAS Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-gray-900">DAS Knowledge Base</h1>
              <p className="text-sm text-gray-500">Help & Documentation</p>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <SearchBar
            placeholder="Search documentation..."
            className="w-80 hidden lg:block"
            showFilters={false}
            onSearch={handleSearch}
          />

          <div className="flex items-center space-x-2">
            <button className="p-2 rounded-md hover:bg-gray-100 transition-colors duration-200 block lg:hidden" onClick={goSearch}>
              <Search className="h-5 w-5 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
